import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import StorageUploadModal from './StorageUploadModal'
import { actions, types } from '../../../store'

const mapStateToProps = state => ({
  status: state.modal.storageUploadModal,
  uploadedTable: state.upload.uploadedTable,
  acceptedFiles: state.upload.acceptedFiles,
  uploadedFiles: state.upload.uploadedFiles
})

const mapDispatchToProps = dispatch => bindActionCreators({
  closeModal: () => actions.modal.setModal(types.MODAL_STORAGE_UPLOAD, false),
  addAcceptedFiles: actions.upload.addAcceptedFiles,
  updateUploadedTable: actions.upload.updateUploadedTable,
  setUploadedDefaults: actions.upload.setUploadedDefaults,
  getStorage: actions.storage.getStorage
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StorageUploadModal)



// WEBPACK FOOTER //
// ./src/components/Modals/StorageUploadModal/index.js